import React from 'react';
import theme from './PriceRowEditor.module.scss';
import { Button } from '@/components/Buttons';
import { Trans } from '@lingui/react/macro';
import PriceRowEditorTotal from './PriceRowEditorTotal';
import { PriceRow } from '@/seller/components/PriceRow';

interface PriceRowEditorFooterProps {
    rows: PriceRow[];
    onAddRowClick?(): void;
}

const PriceRowEditorFooter: React.FC<PriceRowEditorFooterProps> = ({ rows, onAddRowClick }) => {
    return (
        <div className={theme.footer}>
            {onAddRowClick && (
                <Button color="link" onClick={onAddRowClick}>
                    <Trans>Add a new row</Trans>
                </Button>
            )}

            <PriceRowEditorTotal rows={rows} />
        </div>
    );
};

export default PriceRowEditorFooter;
